import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { useSelector } from "react-redux";
import { SearchFilter } from "../models/DashboardModels";
import { DEFAULT_OPTION, LINE_OF_BUSINESS, MIN_DATE_REPORTS } from "../utils/Constant";
import { FormUtils } from "../utils/FormUtils";
import SearchBox from "../components/SearchBox";
import SelectBox from "../components/SelectBox";
import { filterDepartments, getDepartmentData, getGrievanceTypeData } from "../utils/Util";
import KDatePicker from "../components/KDatePicker";
import moment from "moment";
import { mapLOBMaster } from "../utils/MastersMapping";

interface ViewFilterProps {
  onApplyFilters: (viewFilter: SearchFilter) => void;
  setSearchTerms: (data: any) => void;
}

const DashboardFilters = ({
  onApplyFilters,
  setSearchTerms
}: ViewFilterProps) => {

  const [viewFilter, setViewFilter] = useState<SearchFilter>({
    mobileNumber: 'ALL',
    policyNumber: 'ALL',
    status: DEFAULT_OPTION,
    complaintMode: DEFAULT_OPTION,
    department: DEFAULT_OPTION,
    source: DEFAULT_OPTION,
    grievanceType: DEFAULT_OPTION,
    lob: DEFAULT_OPTION,
    requestType: DEFAULT_OPTION,
    createdDate: undefined,
    closureDate: undefined,
  });

  const onResetFilter = () => {
    const resetFilter = {
      mobileNumber: 'ALL',
      policyNumber: 'ALL',
      status: DEFAULT_OPTION,
      complaintMode: DEFAULT_OPTION,
      department: DEFAULT_OPTION,
      source: DEFAULT_OPTION,
      grievanceType: DEFAULT_OPTION,
      lob: DEFAULT_OPTION,
      requestType: DEFAULT_OPTION,
      createdDate: undefined,
      closureDate: undefined,
    };
    onApplyFilters(resetFilter);
    setViewFilter(resetFilter);
    setValidateMobileFlag(false);
    setValidatePolicyFlag(false);
    setSearchTerms({})
  };

  const {
    storeStatusData,
    storeComplaintModeData,
    storeDepartmentData,
    storeComplaintSourceData,
    storeGrievanceTypeData,
    storeLOBData,
    storeRequesTypeData
  } = useSelector((state: any) => state.grievances);

  const complaintModeData = FormUtils.convertDataList(
    storeComplaintModeData.data ?? []
  );

  const statusData = FormUtils.convertDataList(
    storeStatusData.data ?? []
  );

  const departmentData = filterDepartments(getDepartmentData(
    storeDepartmentData.data ?? []
  ));

  const complaintSourceData = FormUtils.convertDataList(
    storeComplaintSourceData.data?? []
  );

  const grievanceTypeData = getGrievanceTypeData(FormUtils.convertDataList(
      storeGrievanceTypeData?.data ?? []
  ));

  const lobData = FormUtils.convertDataList(
    storeLOBData.data?? []
  );

  const requestTypeData = FormUtils.convertDataList(
    storeRequesTypeData.data?? []
  );

  const [validateMobileFlag, setValidateMobileFlag] = useState(false);
  const [validatePolicyFlag, setValidatePolicyFlag] = useState(false);
  const [departmentList, setDepartmentList] = useState(departmentData);

  useEffect(() => {
    let lob = viewFilter.lob;
    if(typeof lob?.value === 'number' && mapLOBMaster(lob?.value) !== 'N/A'){      
      setDepartmentList(departmentData?.filter((each: any) => {
        return lob?.value === LINE_OF_BUSINESS.TO_BE_ASSIGNED ? true 
               : (each?.label == 'GRO'|| each?.label == 'To Be Assigned') ? true :
               lob?.value === each?.lobId;
      }))
    }
    else{
      setDepartmentList(departmentData);
    }
  },[viewFilter.lob, departmentData])

  const handleValidation = (pattern: any, value: any, setFlag: any) => {
    let regexPattern = new RegExp(pattern);
    if (!regexPattern.test(value) && value.length > 0) {
      setFlag(true);
    } else {
      setFlag(false);
    }
  };
  return (
    <div className="border rounded ps-3 pt-2 pe-3 pb-3 mb-3">
      <Row className="mb-2">
        <Col xs={6} md={2}>
          <SearchBox
            label="Search by Mobile Number"
            placeHolder="Ex. 9638527410"
            maxLength={10}
            validateFlag={validateMobileFlag}
            value={viewFilter.mobileNumber !== 'ALL' ? viewFilter.mobileNumber : ''}
            onChange={(e) => {
              setViewFilter({
                ...viewFilter,
                mobileNumber: e.target.value,
              });
              handleValidation('^[0-9]*$', e.target.value, setValidateMobileFlag);
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SearchBox
            label="Search by Policy Number"
            placeHolder="Ex. 123965700"
            validateFlag={validatePolicyFlag}
            value={viewFilter.policyNumber !== 'ALL' ? viewFilter.policyNumber : ''}
            onChange={(e) => {
              setViewFilter({
                ...viewFilter,
                policyNumber: e.target.value,
              });
            }}
          />
        </Col>

        <Col xs={6} md={2}>
          <SelectBox
            label="Mode of Complaint"
            value={viewFilter.complaintMode}
            options={complaintModeData}
            onChange={(event: any) => {
              setViewFilter({
                ...viewFilter,
                complaintMode: event,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SelectBox
            label="Status"
            options={statusData}
            className="css-select-bg"
            value={viewFilter.status}
            onChange={(value: any) => {
              setViewFilter({
                ...viewFilter,
                status: value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SelectBox
            label="Department"
            options={departmentList}
            className="css-select-bg"
            value={viewFilter.department}
            onChange={(value: any) => {
              setViewFilter({
                ...viewFilter,
                department: value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SelectBox
            label="Source of Complaint"
            options={complaintSourceData}
            className="css-select-bg"
            value={viewFilter.source}
            onChange={(value: any) => {
              setViewFilter({
                ...viewFilter,
                source: value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SelectBox
            label="Type of Grievance"
            options={grievanceTypeData}
            className="css-select-bg"
            value={viewFilter.grievanceType}
            onChange={(value: any) => {
              setViewFilter({
                ...viewFilter,
                grievanceType: value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SelectBox
            label="Line of Business"
            options={lobData}
            className="css-select-bg"
            value={viewFilter.lob}
            onChange={(value: any) => {
              setViewFilter({
                ...viewFilter,
                lob: value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SelectBox
            label="Type of Request"
            options={requestTypeData}
            className="css-select-bg"
            value={viewFilter.requestType}
            onChange={(value: any) => {
              setViewFilter({
                ...viewFilter,
                requestType: value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <KDatePicker
            label="Grievance Intimation Date"
            value={viewFilter.createdDate}
            minDate={moment(new Date(MIN_DATE_REPORTS))?.toDate()}
            maxDate={new Date()}
            onChange={(date) => {
              setViewFilter({
                ...viewFilter,
                createdDate: date,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <KDatePicker
            label="Date of Closure"
            maxDate={new Date()}
            minDate={moment(new Date(MIN_DATE_REPORTS))?.toDate()}
            value={viewFilter.closureDate}
            onChange={(date) => {
              setViewFilter({
                ...viewFilter,
                closureDate: date,
              });
            }}
          />
        </Col>
      </Row>

      <Row >
        <Col xs={6} md={3} className="d-flex align-items-center mb-2 buttons-container">
          <button
            className="button"
            onClick={() => {
              onApplyFilters(viewFilter);
            }}
            disabled={validateMobileFlag || validatePolicyFlag}
          >
            {" "}
            Search{" "}
          </button>
          <button
            className="resetButton"
            onClick={() => {
              onResetFilter();
            }}
          >
            {" "}
            Reset{" "}
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardFilters;